
export const setFieldParameter = (updatedFormData, apiResponse) => {
    updatedFormData.initialState.isNotificationBarDisabled = apiResponse?.isActive || false;
    updatedFormData.initialState.startDate = new Date(apiResponse?.startDate) || null;
    updatedFormData.initialState.endDate = new Date(apiResponse?.endDate) || null;
    updatedFormData.initialState.notificationText = apiResponse?.descriptionText || null;
    updatedFormData.initialState.urlLink = apiResponse?.urlLink || null;
    return updatedFormData
}



